import { baseApi } from "./baseApi";

export const appConfigApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppConfigs: builder.query<any, void>({
      query: () => ({ url: `/api/app-config` }),
      providesTags: ["AppConfig"],
    }),
    updateAppConfigs: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/app-config",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["AppConfig"],
    }),
  }),
});

export const { useGetAppConfigsQuery, useUpdateAppConfigsMutation } =
  appConfigApi;
